import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20network%20nodes%20connected%20by%20glowing%20lines%20on%20a%20dark%20sophisticated%20background%2C%20warm%20orange%20and%20teal%20gradient%20accents%2C%20clean%20minimalist%20digital%20landscape%2C%20professional%20technology%20atmosphere%2C%20subtle%20depth%20with%20layered%20transparent%20shapes&width=1800&height=1200&seq=hero-bg-01&orientation=landscape"
        alt="17c.com 官方访问平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-background-50/15 backdrop-blur-sm border border-background-50/20 rounded-full px-4 py-1.5 mb-6">
          <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></div>
          <span className="text-sm text-background-50/90">平台运行稳定 · 最新地址已更新</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
          17c.com 官方入口
          <br />
          <span className="text-primary-400">最新地址直达</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          {siteInfo.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={siteInfo.officialUrl}
            className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-md text-base font-semibold transition-all duration-200 cursor-pointer w-full sm:w-auto"
          >
            <i className="ri-external-link-line mr-2"></i>
            立即进入 17c.com
          </a>
          <Link
            to="/about"
            className="whitespace-nowrap bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm border border-background-50/30 text-background-50 px-8 py-3.5 rounded-md text-base font-medium transition-all duration-200 cursor-pointer w-full sm:w-auto"
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>

        <div className="mt-10 flex items-center justify-center gap-8 text-background-50/60 text-sm">
          <div className="flex items-center gap-1.5">
            <i className="ri-shield-check-line"></i>
            <span>安全加密</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-speed-up-line"></i>
            <span>极速访问</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-customer-service-2-line"></i>
            <span>全天客服</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}